//index.js
import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { StyledEngineProvider } from "@mui/material/styles";
import { ThemeProvider } from "./theme/ThemeProvider";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "./Redux/store";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <ScrollToTop />
      <PersistGate persistor={persistor}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider>
            <App />
          </ThemeProvider>
        </StyledEngineProvider>
      </PersistGate>
    </BrowserRouter>
  </Provider>
);

reportWebVitals();

// Prefer importing from ./Redux/store — kept for any legacy default import of store.
export default store;
